import React from 'react'
import { Lang } from '../types/common-types'
export default React.createContext('rus' as Lang)
